export default "__VITE_ASSET__CVrvbn0N__"